module.exports = __webpack_public_path__ + "img/hero-water-04.d74e80e4.png";